import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { Company } from '@homeviews/models'
import { companiesApi } from '../../services/features/companies'

export const COMPANIES_FEATURE_KEY = 'Companies'

type CompaniesState = {
  companies: Company[]
  status: any
}

const initialCompaniesState: CompaniesState = {
  companies: [],
  status: {},
}

export const CompaniesSlice = createSlice({
  name: COMPANIES_FEATURE_KEY,
  initialState: initialCompaniesState,
  reducers: {
    setCompanyStatus: (
      state,
      { payload: { data } }: PayloadAction<{ data: any }>,
    ) => {
      state.status = data
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      companiesApi.endpoints.getCompanyStatus.matchFulfilled,
      (state, { payload }) => {
        state.status = payload?.data
      },
    )
  },
})

/*
 * Export reducer for store configuration.
 */
export const companiesReducer = CompaniesSlice.reducer

export const { setCompanyStatus } = CompaniesSlice.actions

export const getCompaniesState = (rootState: unknown): CompaniesState =>
  rootState[COMPANIES_FEATURE_KEY]

export const getCompanyStatus = (rootState: unknown): CompaniesState =>
  rootState[COMPANIES_FEATURE_KEY]?.status
